//
//
//
//

import ModuleDashboardComponent from '@/components//ModuleDashboardComponent.vue';
export default {
  components: {
    ModuleDashboardComponent: ModuleDashboardComponent
  },
  data: function data() {
    return {
      title: 'Reporte de Calidad de Atributos',
      description: 'Pagina de administracion del reporte.',
      id: 'attribute-quality-report',
      module: 'marketplace-atributos'
    };
  }
};